import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Problem from "@/components/site/Problem";
import Solution from "@/components/site/Solution";
import CoInvest from "@/components/site/CoInvest";
import OwnOutright from "@/components/site/OwnOutright";
import HowItWorks from "@/components/site/HowItWorks";
import Comparison from "@/components/site/Comparison";
import Matching from "@/components/site/Matching";
import Benefits from "@/components/site/Benefits";
import Markets from "@/components/site/Markets";
import LeadForm from "@/components/site/LeadForm";
import ReferFamily from "@/components/site/ReferFamily";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "Co-Own Israel — Your home in Israel. Shared or owned entirely. Managed completely.";
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px 300px 0px" }
    );
    const els = document.querySelectorAll(".reveal");
    els.forEach((el) => io.observe(el));

    // Safety net — force any un-revealed element visible after 2.5s
    const failsafe = setTimeout(() => {
      document.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => {
        el.classList.add("is-visible");
      });
    }, 2500);

    return () => {
      io.disconnect();
      clearTimeout(failsafe);
    };
  }, []);

  return (
    <main data-testid="landing-page" className="bg-[var(--bone)] text-[var(--ink)]">
      <Header />
      <Hero />
      <Problem />
      <Solution />
      <CoInvest />
      <OwnOutright />
      <HowItWorks />
      <Comparison />
      <Matching />
      <Benefits />
      <Markets />
      <LeadForm />
      <ReferFamily />
      <Footer />
    </main>
  );
}
